import { render, staticRenderFns } from "./StringListInput.vue?vue&type=template&id=0bb76447&scoped=true&"
import script from "./StringListInput.vue?vue&type=script&lang=js&"
export * from "./StringListInput.vue?vue&type=script&lang=js&"
import style0 from "./StringListInput.vue?vue&type=style&index=0&id=0bb76447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb76447",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
